import { render, staticRenderFns } from "./servidores_chamefacil.vue?vue&type=template&id=69dbc08c"
import script from "./servidores_chamefacil.vue?vue&type=script&lang=js"
export * from "./servidores_chamefacil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports